<form [formGroup]="formGroup">
    <div class="fiscal-data-form m-t-30">
        <!-- FISCAL ROW  1-->
        <div class="d-flex">

            <!-- USER DOCUMENT TYPE-->
            <mat-form-field class="w-per-25 input-regular" appearance="outline">
                <mat-label>{{ 'configuration-page.action-dialog.document-type' | translate }}</mat-label>
                <div matSuffix style="padding-left: 20px;">
                    <fa-icon [icon]="['fal','angle-down']" [rotate]="documentTypeSelected?.panelOpen ? 180 : undefined"
                        class="font-16 chevron-icon"></fa-icon>
                </div>
                <mat-select formControlName="documentType" multiple matNativeControl panelClass="panel-multi-select"
                    id="documentType" #documentTypeSelected>
                    @for (documentType of documentTypes; track documentType) {
                    <mat-option class="panel-mat-option" [value]="documentType" [id]="documentType"
                        (click)="propagateCheck(documentType, 'documentType')">
                        <mat-checkbox [color]="'primary'" [id]="documentType" [value]="documentType"
                            [checked]="isChecked(documentType, 'documentType')">
                            {{ documentType }}
                        </mat-checkbox>
                    </mat-option>
                    }
                </mat-select>

                @if (formGroup.controls['documentType'].hasError('required')) {
                <mat-error id="text-error-input">
                    {{'configuration-page.action-dialog.document-type-required' | translate }}
                </mat-error>
                }
            </mat-form-field>

            <!-- USER DOCUMENT NUMBER-->
            <mat-form-field class="w-per-30 input-regular" appearance="outline">
                <mat-label>{{ 'configuration-page.action-dialog.document-number' | translate }}</mat-label>
                <fa-icon [icon]="['fal', 'xmark']" (click)="clearInput('documentNumber')" [ngClass]="{'icon' : formGroup.get('documentNumber')?.value,
                                'd-none': !formGroup.get('documentNumber')?.value}">
                </fa-icon>

                <input type="text" matInput formControlName="documentNumber" id="input-documentNumber">
                @if (formGroup.controls['documentNumber'].hasError('required')) {
                <mat-error id="text-error-input">
                    {{'configuration-page.action-dialog.document-number-required' | translate }}
                </mat-error>
                }
            </mat-form-field>

            <!-- USER FISCAL NAME-->
            <mat-form-field class="w-per-45 input-regular" appearance="outline">
                <mat-label>{{ 'configuration-page.action-dialog.fiscal-name' | translate }}</mat-label>
                <fa-icon [icon]="['fal', 'xmark']" (click)="clearInput('fiscalName')" [ngClass]="{'icon' : formGroup.get('fiscalName')?.value,
                                            'd-none': !formGroup.get('fiscalName')?.value}">
                </fa-icon>

                <input type="text" matInput formControlName="fiscalName" id="input-fiscalName">

                @if (formGroup.controls['fiscalName'].hasError('required')) {
                <mat-error id="text-error-input">
                    {{'configuration-page.action-dialog.fiscal-name-required' | translate }}
                </mat-error>
                }
            </mat-form-field>
        </div>

        <!-- FISCAL ROW  2-->
        <div class="d-flex">

            <!-- USER ADDRESS-->
            <mat-form-field class="w-per-35 input-regular" appearance="outline">
                <mat-label>{{ 'configuration-page.action-dialog.address' | translate }}</mat-label>
                <fa-icon [icon]="['fal', 'xmark']" (click)="clearInput('address')" [ngClass]="{'icon' : formGroup.get('address')?.value,
                'd-none': !formGroup.get('address')?.value}">
                </fa-icon>

                <input type="text" matInput formControlName="address" id="input-address">
            </mat-form-field>

            <!-- USER COUNTRY-->
            <mat-form-field class="w-per-30 input-regular" appearance="outline">
                <mat-label>{{ 'configuration-page.action-dialog.country' | translate }}</mat-label>
                <div matSuffix style="padding-left: 20px;">
                    <fa-icon [icon]="['fal','angle-down']" [rotate]="countrySelected?.panelOpen ? 180 : undefined"
                        class="font-16 chevron-icon"></fa-icon>
                </div>
                <mat-select formControlName="country" multiple matNativeControl panelClass="panel-multi-select"
                    id="country" #countrySelected>
                    @for (country of countries; track country) {
                    <mat-option class="panel-mat-option" [value]="country.countryId" [id]="country.countryId"
                        (click)="propagateCheck(country.countryId, 'country')">
                        <mat-checkbox [color]="'primary'" [id]="country.countryId" [value]="country.countryId"
                            [checked]="isChecked(country.countryId, 'country')">
                            {{ country.description }}
                        </mat-checkbox>
                    </mat-option>
                    }
                </mat-select>
                @if (formGroup.controls['country'].hasError('required')) {
                <mat-error id="text-error-input">
                    {{'configuration-page.action-dialog.country-required' | translate }}
                </mat-error>
                }
            </mat-form-field>

            <!-- USER COUNTRY DIVISION-->
            <mat-form-field class="w-per-30 input-regular" appearance="outline"
                [ngClass]="{'disabled': !countryDivision.length}">
                <mat-label>{{ 'configuration-page.action-dialog.country-divition' | translate }}</mat-label>
                <div matSuffix style="padding-left: 20px;">
                    <fa-icon [icon]="['fal','angle-down']"
                        [rotate]="countryDivisionSelected?.panelOpen ? 180 : undefined"
                        class="font-16 chevron-icon"></fa-icon>
                </div>
                <mat-select formControlName="countryDivition" multiple matNativeControl panelClass="panel-multi-select"
                    id="country" #countryDivisionSelected>
                    @for (countryDivition of countryDivision; track countryDivition) {
                    <mat-option class="panel-mat-option" [value]="countryDivition.countryDivisionId"
                        [id]="countryDivition.countryDivisionId"
                        (click)="propagateCheck(countryDivition.countryDivisionId, 'countryDivition')">
                        <mat-checkbox [color]="'primary'" [id]="countryDivition.countryDivisionId"
                            [value]="countryDivition.countryDivisionId"
                            [checked]="isChecked(countryDivition.countryDivisionId, 'countryDivition')">
                            {{ countryDivition.description }}
                        </mat-checkbox>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <!-- USER COUNTRY DESTINATION-->
            <mat-form-field class="w-per-30 input-regular" appearance="outline"
                [ngClass]="{'disabled': !countryDestinations.length}">
                <mat-label>{{ 'configuration-page.action-dialog.country-destination' | translate }}</mat-label>
                <div matSuffix style="padding-left: 20px;">
                    <fa-icon [icon]="['fal','angle-down']"
                        [rotate]="countryDestinationSelected?.panelOpen ? 180 : undefined"
                        class="font-16 chevron-icon"></fa-icon>
                </div>
                <mat-select formControlName="destination" multiple matNativeControl panelClass="panel-multi-select"
                    id="country" #countryDestinationSelected>
                    @for (destination of countryDestinations; track destination) {
                    <mat-option class="panel-mat-option" [value]="destination.destinationId"
                        [id]="destination.destinationId"
                        (click)="propagateCheck(destination.destinationId, 'destination')">
                        <mat-checkbox [color]="'primary'" [id]="destination.destinationId"
                            [value]="destination.destinationId"
                            [checked]="isChecked(destination.destinationId, 'destination')">
                            {{ destination.description }}
                        </mat-checkbox>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>


        </div>
    </div>
</form>